import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "dienst-tabel"
    }}>{`Dienst-tabel`}</h1>
    <p>{`De dienst-tabel toont alle gepubliceerde diensten met een aanvangstdatum van 1 januari 2016 tot 1 januari 2021. De volgende velden zijn opgenomen:`}</p>
    <h2 {...{
      "id": "bezettingbenodigd"
    }}>{`BezettingBenodigd`}</h2>
    <p><inlineCode parentName="p">{`BezettingBenodigd`}</inlineCode>{` is het totale aantal medewerkers dat  gewenst is voor deze dienst.
Niet alle medewerkers tellen mee voor de bezetting, bijvoorbeeld stagiairs. Met het `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster#isbezetting"
      }}>{`isBezetting-veld`}</a>{` is in Power BI te zien of een medewerker meetelt voor de bezetting.`}</p>
    <h2 {...{
      "id": "dienstdatum"
    }}>{`DienstDatum`}</h2>
    <p><inlineCode parentName="p">{`DienstDatum`}</inlineCode>{` bevat de geplande aanvangstdatum van deze dienst. Individuele medewerkers kunnen in het `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster#roosterdatum"
      }}>{`gepubliceerde rooster`}</a>{` van deze datum afwijken.
Gebruik `}<a parentName="p" {...{
        "href": "#dienststarttijd"
      }}>{`DienstStarttijd`}</a>{` voor de aanvangstdatum mét tijd.`}</p>
    <h2 {...{
      "id": "dienstid"
    }}>{`DienstID`}</h2>
    <p><inlineCode parentName="p">{`DienstID`}</inlineCode>{` is het unieke nummer van een dienst in Uurwerk. Met dit nummer verbindt Power BI diensten aan bijhorende `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster#dienstid"
      }}>{`roosters`}</a>{`.`}</p>
    <h2 {...{
      "id": "dienstjaar"
    }}>{`DienstJaar`}</h2>
    <p><inlineCode parentName="p">{`DienstJaar`}</inlineCode>{` is het jaar van de `}<a parentName="p" {...{
        "href": "#dienstdatum"
      }}>{`DienstDatum`}</a>{`.`}</p>
    <h2 {...{
      "id": "dienstseizoen"
    }}>{`DienstSeizoen`}</h2>
    <p><inlineCode parentName="p">{`DienstSeizoen`}</inlineCode>{` is het seizoen van de `}<a parentName="p" {...{
        "href": "#dienstdatum"
      }}>{`DienstDatum`}</a>{`, bijvoorbeeld `}<inlineCode parentName="p">{`'19-'20`}</inlineCode>{`. Een seizoen wordt gerekend vanaf 1 september.`}</p>
    <h2 {...{
      "id": "dienststarttijd"
    }}>{`DienstStarttijd`}</h2>
    <p><inlineCode parentName="p">{`DienstStarttijd`}</inlineCode>{` bevat de geplande aanvangstdatum `}<em parentName="p">{`en -tijd`}</em>{` van deze dienst. Individuele medewerkers kunnen in het `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/gepubliceerdrooster#roosterstarttijd"
      }}>{`gepubliceerde rooster`}</a>{` van deze tijd afwijken. Gebruik `}<a parentName="p" {...{
        "href": "#dienstdatum"
      }}>{`DienstDatum`}</a>{` voor de aanvangstdatum zonder tijd.`}</p>
    <h2 {...{
      "id": "dienstweekiso"
    }}>{`DienstWeekISO`}</h2>
    <p><inlineCode parentName="p">{`DienstWeekISO`}</inlineCode>{` is is het weeknummer van de `}<a parentName="p" {...{
        "href": "#dienstdatum"
      }}>{`DienstDatum`}</a>{`. `}</p>
    <h2 {...{
      "id": "discipline"
    }}>{`Discipline`}</h2>
    <p><inlineCode parentName="p">{`Discipline`}</inlineCode>{` geeft de discipline van deze dienst weer.`}</p>
    <h2 {...{
      "id": "evenementid"
    }}>{`EvenementID`}</h2>
    <p><inlineCode parentName="p">{`EvenementID`}</inlineCode>{` is het unieke nummer van het evenement in Uurwerk waar deze dienst bij hoort. Met dit nummer verbindt Power BI de dienst aan het bijhorende `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/evenement#evenementid"
      }}>{`evenement`}</a>{`.`}</p>
    <h2 {...{
      "id": "omschrijving"
    }}>{`Omschrijving`}</h2>
    <p><inlineCode parentName="p">{`Omschrijving`}</inlineCode>{` geeft de omschrijving van de dienst weer.`}</p>
    <h2 {...{
      "id": "locatie"
    }}>{`Locatie`}</h2>
    <p><inlineCode parentName="p">{`Locatie`}</inlineCode>{` geeft de naam van de locatie van deze dienst weer.`}</p>
    <h2 {...{
      "id": "roostergroepid"
    }}><del parentName="h2">{`RoostergroepID`}</del></h2>
    <p><inlineCode parentName="p">{`RoostergroepID`}</inlineCode>{` is het unieke nummer in Uurwerk voor de roostergroep waar deze dienst bij hoort. Dit veld is per `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/changelog"
      }}>{`7 november`}</a>{` verwijderd. In plaats van dit veld, gebruik het veld `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker#roostergroep"
      }}>{`Roostergroep`}</a>{` in de tabel `}<a parentName="p" {...{
        "href": "/powerbi/tabellen/medewerker"
      }}>{`Medewerker`}</a></p>
    <h2 {...{
      "id": "metingen"
    }}>{`Metingen`}</h2>
    <p>{`Hieronder staan veelgebruikte metingen beschreven.  `}</p>
    <h3 {...{
      "id": "aantaldiensten"
    }}>{`AantalDiensten`}</h3>
    <p><inlineCode parentName="p">{`AantalDiensten`}</inlineCode>{` telt het unieke aantal diensten.`}</p>
    <pre><code parentName="pre" {...{}}>{`AantalDiensten = DISTINCTCOUNT(Dienst[DienstID])
`}</code></pre>
    <h3 {...{
      "id": "dienstjaarweekiso-kolom"
    }}>{`DienstJaarWeekISO (kolom)`}</h3>
    <p><inlineCode parentName="p">{`DienstJaarWeekISO`}</inlineCode>{` is een kolom voor de diensttabel, die we`}</p>
    <pre><code parentName="pre" {...{}}>{`DienstJaarWeekISO = 
    INT(                                 // rond het volgende af op hele getallen:
        VALUE(                           // lees de volgende tekst als een getal:
            year(Dienst[DienstDatum])    // het jaar van de DienstDatum
            &                            // met daaraan vastgeplakt,
            RIGHT(                       // de twee rechter tekens van het weeknummer + 100:
                WEEKNUM(                 // het ISO weeknummer 
                    Dienst[DienstDatum]; // ... van DienstDatum
                    2                    // ... gerekend met maandag als eerste dag van de week
                )                        
                + 100;                   // 100 erbij opgeteld, zodat we een extra 0 hebben bij weeknummers onder de 10
                2                        // twee tekens
            )
        )
    )

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      